import React, { useMemo } from 'react'
import styled from 'styled-components'
import { ChoiceGroup } from '@fluentui/react/lib/ChoiceGroup'
import { PanelView } from '../panels/PanelView'
import { ContainerPanel } from '../panels/ContainerPanel'
import { useTranslation } from 'react-i18next'
import { itemHelper } from '../../common/src/helpers'
import { customEffortFormatter } from './commonEffort'

const Note = styled.p`
  color: ${p => p.theme.palette.neutralTertiary};
  font-size: small;
  text-align: justify;
`

const CUSTOM_KEY = 'CUSTOM'

export const EffortSelectionView = ({ effort = 0, estimatedEffort = 0, onChange }) => {
  const { t } = useTranslation()

  const effortLongStrings = useMemo(
    () => ({
      [itemHelper.EFFORT_KEYS.NO_EFFORT]: t('item.effort.long.no_effort'),
      [itemHelper.EFFORT_KEYS.ONE_HOUR]: t('item.effort.long.one_hour'),
      [itemHelper.EFFORT_KEYS.TWO_HOURS]: t('item.effort.long.two_hours'),
      [itemHelper.EFFORT_KEYS.HALF_A_DAY]: t('item.effort.long.half_day'),
      [itemHelper.EFFORT_KEYS.ONE_DAY]: t('item.effort.long.one_day'),
      [itemHelper.EFFORT_KEYS.HALF_A_WEEK]: t('item.effort.long.half_week'),
      [itemHelper.EFFORT_KEYS.ONE_WEEK]: t('item.effort.long.one_week'),
      [itemHelper.EFFORT_KEYS.TWO_WEEKS]: t('item.effort.long.two_weeks'),
      [itemHelper.EFFORT_KEYS.ONE_MONTH]: t('item.effort.long.one_month'),
      [itemHelper.EFFORT_KEYS.SEVERAL_MONTHS]: t('item.effort.long.several_months'),
    }),
    [t]
  )

  const options = Object.keys(effortLongStrings).map(key => ({ key: +key, text: effortLongStrings[key] }))
  let selectedKey = effort

  const shouldDisplayCustom = estimatedEffort !== itemHelper.DEFAULT_ESTIMATED_EFFORT[effort]
  if (shouldDisplayCustom) {
    const { unit, value } = customEffortFormatter(estimatedEffort)
    options.push({ key: CUSTOM_KEY, text: t(`item.effort.long.custom_${unit}`, { count: value }), disabled: true })
    selectedKey = CUSTOM_KEY
  }

  const localOnChange = React.useCallback((evt, opt) => onChange?.(opt.key), [onChange])
  return (
    <PanelView>
      <ChoiceGroup
        options={options}
        selectedKey={selectedKey}
        label={t('item.effort.title')}
        onChange={localOnChange}
      />
      <Note>{t('item.effort.note')}</Note>
    </PanelView>
  )
}

export const EffortSelectionPanel = ({ effort, estimatedEffort, onChange, ...rest }) => {
  return (
    <ContainerPanel {...rest}>
      <EffortSelectionView effort={effort} estimatedEffort={estimatedEffort} onChange={onChange} />
    </ContainerPanel>
  )
}
